import React from 'react';
import { SetState } from 'types/props';

export interface MapSearchBoxContextData {
  searchText: string;
  searchBoxPosition: 'top-right' | 'bottom-right' | 'top-left' | 'bottom-left';
  setSearchText: SetState<string>;
}

export const MapSearchBoxContext = React.createContext<MapSearchBoxContextData>({
  searchText: '',
  searchBoxPosition: 'top-left',
  setSearchText: () => null,
});
